// Part of reportPages, split by screen to keep files short; ../reportPages.ts merges the parts.
// Keys sit directly under reportPages, in sub-objects whose names no other part uses.
export const en = {};

export const ar = {};
